import type { ReactNode } from 'react';
import { memo } from 'react';
import { StyleSheetManager } from 'styled-components';
import { WebAppGlobalStyle } from './WebAppGlobalStyle';

export type WebAppStyleProviderProps = {
  children: ReactNode;
};

/** wraps the root of the web app and provides global styles */
export const WebAppStyleProvider = memo(
  ({ children }: WebAppStyleProviderProps) => {
    return (
      <StyleSheetManager enableVendorPrefixes={true}>
        <WebAppGlobalStyle />
        {children}
      </StyleSheetManager>
    );
  }
);
